var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 27.519A1.51 1.51 0 005.5 26c-.828 0-1.5.68-1.5 1.519v4.962A1.51 1.51 0 005.5 34c.828 0 1.5-.68 1.5-1.519v-4.962zM13 24.385C13 23.62 12.328 23 11.5 23s-1.5.62-1.5 1.385v9.23c0 .765.672 1.385 1.5 1.385s1.5-.62 1.5-1.385v-9.23zM18 19.417c0-.783-.672-1.417-1.5-1.417s-1.5.634-1.5 1.417v14.166c0 .783.672 1.417 1.5 1.417s1.5-.634 1.5-1.417V19.417zM24 15.432C24 14.64 23.328 14 22.5 14s-1.5.641-1.5 1.432v18.136c0 .791.672 1.432 1.5 1.432s1.5-.641 1.5-1.432V15.432zM38.532 24c-.499.007-.995.084-1.473.228.24-.787.368-1.605.38-2.428a8.826 8.826 0 00-2.563-6.223A8.722 8.722 0 0028.69 13a7.744 7.744 0 00-1.69.211V35h11.532c1.45 0 2.841-.58 3.867-1.61A5.517 5.517 0 0044 29.5a5.517 5.517 0 00-1.602-3.89A5.452 5.452 0 0038.532 24z",
    fill: "#FFAB66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.ac63f39f43f34a5821e51ab1d9b3a199.svg";
export { ForwardRef as ReactComponent };